import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        // Shared Spectrum sign-in screen from `common` — same one-line mount as
        // every other v2 module; SPECTRUM_AUTH_API is provided in app.config.ts.
        path: 'login',
        loadComponent: () => import('common').then(m => m.SpectrumLoginComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            {
                path: 'home',
                loadComponent: () => import('./screens/dashboard/dashboard.component').then(m => m.DashboardComponent)
            }
        ]
    },
    { path: '**', redirectTo: '' }
];
